export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";